import {Component, Input, OnInit} from '@angular/core';
import {FormArray, FormBuilder} from "@angular/forms";
import {ICamp} from "../../model/camp.model";
import {ICampAvis} from "../../model/camp-avis.model";
import {CampModuleEnum, TypeAvisEnum, TypeCampGroupEnum} from "../../constant/enum";
import {isCampModulesActive} from "../../util/camp-utils";
import {CampService} from "../../service/camp.service";
import {Router} from "@angular/router";


@Component({
    selector: 'ddc-camp-avis',
    templateUrl: './camp-avis.component.html',
    styleUrls: ['./camp-avis.component.scss'],
    standalone: false
})
export class CampAvisComponent {

  @Input() set avisToDisplay(avisToDisplay: []){
    this._avisToDisplay = avisToDisplay;
  };

  @Input() set campAvisFormArray(campAvisFormArray: FormArray) {
    this._campAvisFormArray = campAvisFormArray;
  };

  @Input() set currentCamp(currentCamp: ICamp){
    this._currentCamp = currentCamp;
  };

  @Input() set titleLabelKey(titleLabelKey: string) {
    this._titleLabelKey = titleLabelKey;
  }

  @Input() set descriptionLabelKey(descriptionLabelKey: string) {
    this._descriptionLabelKey = descriptionLabelKey;
  }

  _currentCamp: ICamp;
  _campAvisFormArray: FormArray;
  _avisToDisplay: ICampAvisParameters[] = [];
  _titleLabelKey: string;
  _descriptionLabelKey: string;

  constructor(
    protected fb: FormBuilder,
  ) {}

  /**
   * Get the form control by typeAvis and form control name to link it to the correct field in the screen
   */
  getAvisFormControl(avis, formControlName: string) {
    const allTmpCampAvis = this._campAvisFormArray.getRawValue();
    const index = allTmpCampAvis.findIndex((tmpCampAvis: ICampAvis) => tmpCampAvis.typeAvis === avis.typeAvis);
    if (index !== -1) {
      return this._campAvisFormArray.at(index).get(formControlName);
    }
    return null;
  }

   getAvisToDisplay() {
    const avisToDisplay = this._avisToDisplay.filter(avis =>
        this._currentCamp.typeCamp && avis.displayForCampGroup.includes(this._currentCamp.typeCamp.codeGroupeCamp) &&
        (
            (this._currentCamp._isCampPere === false && this._currentCamp._isCampEnfant === false) ||
            (this._currentCamp._isCampPere === true && avis.displayForCampPere === true) ||
            (this._currentCamp._isCampEnfant === true && avis.displayForCampEnfant == true)
        )
    );

      if (!isCampModulesActive(this._currentCamp, [CampModuleEnum.MARIN, CampModuleEnum.MARIN_1, CampModuleEnum.MARIN_2])) {
        this.removeAvisByTypeAvis(avisToDisplay, TypeAvisEnum.MARIN)
      }

      if (!isCampModulesActive(this._currentCamp, [CampModuleEnum.INTERNATIONAL_8_17, CampModuleEnum.INTERNATIONAL_COMP])) {
        this.removeAvisByTypeAvis(avisToDisplay, TypeAvisEnum.INTERNATIONAL)
      }
    return avisToDisplay;
  }

   removeAvisByTypeAvis(avisToDisplay, typeAvis) {
    const avisIndex = avisToDisplay.findIndex((avisToDisplay) => avisToDisplay.typeAvis === typeAvis);
    if (avisIndex === -1 ) return avisToDisplay;
    avisToDisplay.splice(avisIndex, 1);
    return avisToDisplay;
  }

  displayAvis(avis: any) {
    if(this._currentCamp && this._currentCamp._droitsUtilisateurCourant[avis.droit]) {
      return true;
    }
    return false;
  }

}

export interface ICampAvisParameters {
  typeAvis: TypeAvisEnum;
  listAvis: ICampListAvis[];
  labelKey: string;
  droit: string;
  displayForCampGroup: TypeCampGroupEnum[],
  displayForCampEnfant: boolean,
  displayForCampPere: boolean
}

export interface ICampListAvis {
  value: string;
  text: string;
}
